export class DictionariesPageProps {
  public dictionary: string | null = null

  public page: number | null = null

  constructor(init?: Partial<DictionariesPageProps>) {
    Object.assign(this, init);
  }
}
